import script from "./chat-composer.vue?vue&type=script&setup=true&lang=js"
export * from "./chat-composer.vue?vue&type=script&setup=true&lang=js"

import "./chat-composer.vue?vue&type=style&index=0&id=1e40b6f2&lang=css"

const __exports__ = script;

export default __exports__